import * as React from "react";
const SvgHeartOutlineG900 = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" {...props}>
    <path
      stroke="#505050"
      strokeLinejoin="round"
      strokeWidth={0.9}
      d="M8.95 5.523c-.265-1.477-1.555-2.586-3.084-2.52-1.869.08-3.15 1.934-2.812 3.824.524 2.926 4.064 4.783 5.946 7.83 1.882-3.047 5.422-4.904 5.946-7.83.338-1.89-.943-3.744-2.812-3.824-1.53-.066-2.818 1.043-3.085 2.52z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgHeartOutlineG900;
